import type { ReactNode } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'
import { useAuthStore } from '@/features/auth/store'
import { safeRedirect } from '@/shared/routing/allowed-redirects'

export function PublicRoute({ children }: { children: ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const [searchParams] = useSearchParams()

  // Signing in here is how a user gets back to where they were sent from: the
  // membership login wall bounces app arrivals through /login with
  // `?redirect=/membership-info`, and without honouring it they would land on
  // /onboarding having lost the screen they actually asked for.
  //
  // Same allow-list as /autologin — a crafted `?redirect=` must not be able to
  // turn our login page into an open redirect. An absent or rejected value
  // yields DEFAULT_DESTINATION, which is the '/onboarding' this guard always
  // used, so the pre-existing behaviour is unchanged.
  if (isAuthenticated) {
    return <Navigate to={safeRedirect(searchParams.get('redirect'))} replace />
  }
  return <>{children}</>
}
